import { eventNoopHandler } from './daypicker-decorator';

function monthPickerDecorator($provide) {
  function monthPickerDirective($delegate) {
    let link;

    // since: directives could potentially share names, the provider returns an array
    // therefore: get the first item as we know we only have one.
    const directive = $delegate[0];

    // reference the original link function
    link = directive.link;

    //redefine the compile to do both the old link function and add additional scoped functions
    directive.compile = () => {
      return function(scope, element, attrs, controller) {
        let updateMin, updateMax;
        const ctrl = controller[0];

        Reflect.apply(link, this, arguments);

        //overrides datepicker.js keydown event
        element.bind('keydown', eventNoopHandler.arrowKeysEventNoop);
        element.bind('click', eventNoopHandler.anyEventNoop);

        //disable navigation according to the range
        scope.monthpickerNavPrevDisabled = () => {
          const firstMonth = new Date(ctrl.activeDate.getFullYear(), 0, 1);

          return ctrl.minDate && firstMonth <= ctrl.minDate;
        };

        scope.monthpickerNavNextDisabled = () => {
          const lastMonth = new Date(ctrl.activeDate.getFullYear(), 11, 31);

          return ctrl.maxDate && lastMonth >= ctrl.maxDate;
        };

        updateMax = scope.$on('monthpicker.updateMaxDate', (e, info) => {
          ctrl.maxDate = info.maxDate;
          if (info.reset || ctrl.activeDate.getTime() > ctrl.maxDate.getTime()) {
            ctrl.activeDate = info.selectedDate || new Date();
          }
          ctrl.refreshView();
        });

        updateMin = scope.$on('monthpicker.updateMinDate', (e, info) => {
          ctrl.minDate = info.minDate;
          if (info.reset || ctrl.activeDate.getTime() < ctrl.minDate.getTime()) {
            ctrl.activeDate = info.selectedDate || new Date();
          }
          ctrl.refreshView();
        });

        scope.$on('$destroy', () => {
          element.off('keydown');
          element.off('click');
          updateMax();
          updateMin();
        });
      };
    };
    return $delegate;
  }

  monthPickerDirective.$inject = ['$delegate'];
  $provide.decorator('uibMonthpickerDirective', monthPickerDirective);
}

monthPickerDecorator.$inject = ['$provide'];
export default monthPickerDecorator;
